document.addEventListener("DOMContentLoaded", function() {
  $('.slider-fade').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    fade: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 800,
    cssEase: 'linear',

    prevArrow: `
      <button type="button" class="slick-prev custom-arrow">
        <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
          <path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    `,

    nextArrow: `
      <button type="button" class="slick-next custom-arrow">
        <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
          <path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    `
  });
});



document.addEventListener("DOMContentLoaded", function() {
  $('.slider-new').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    fade: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 800,
    cssEase: 'linear',
    appendArrows: '.slick_button_new',

    prevArrow: `
      <button type="button" class="slick-prev custom-arrow">
        <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
          <path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    `,

    nextArrow: `
      <button type="button" class="slick-next custom-arrow">
        <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
          <path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    `
  });
});



$(document).ready(function(){

  $('.hsggs_test_wrap').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 600,
    arrows: true,

    prevArrow: `<button type="button" class="slick-prev nt-arrow nt-prev">
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
        <path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>`,

    nextArrow: `<button type="button" class="slick-next nt-arrow nt-next">
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
        <path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>`,

    responsive: [
      {
        breakpoint: 992,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 }
      }
    ]
  });

});

